import Button from '@mui/material/Button';
import React from 'react'
import { styled } from '@mui/material/styles';

const BootstrapButton = styled(Button)(
    {
        boxShadow: 'none',
        textTransform: 'none',
        fontSize: '10px',
        padding: '10px 14px',
        border: '1px solid',
        borderRadius: '50px',
        lineHeight: 1.5,
        '&:hover': {
            boxShadow: 'none',
        },
        '&:active': {
            boxShadow: 'none',

        },
        '&:focus': {
            boxShadow: '0 0 0 0.2rem rgba(0,123,255,.5)',
        },
    });

const CustomButton = ({ children,fontSize, padding, height,width,variant, type, color, handleClick,margin, disabled }) => {

    return (
        <BootstrapButton className="font-josefin-sans-bold"  type={type} onClick={handleClick}
        disabled={disabled}    
        sx={{
                width:width,
                height:height,
                background: color,
                fontSize:fontSize,
                padding: padding,
                border: color,
                margin:margin,
                "&:hover": {
                    backgroundColor: color,
                    border: color,
                },
                '&:active': {
                    boxShadow: 'none',
        
                },
                '&:focus': {
                    boxShadow: '0 0 0 0.2rem rgba(0,123,255,.5)',
                },
            }} variant={variant} >
            {children}
        </BootstrapButton>
    )
}

export default CustomButton